import {useEffect, useState} from "react";
import axios from "axios";
import {APP_URLS} from "../app/config";
import {apiClient} from "../providers/apiClient";

const useSectors = () => {
    const [sectors, setSectors] = useState([]);
    const [appSectors, setAppSectors] = useState([]);
    const [sectorTypes, setSectorTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    
    
    useEffect(() => {
        const newArray = sectors.map(sector => {
            return {
                value: sector.id,
                text: sector.name
            }
        })

        setAppSectors(newArray);
    }, [sectors]);
    
    
    const fetchSectors = () => {
        axios.get(APP_URLS.SECTORS_LIST).then(result => {
            setSectors(result.data);
        }).finally(() => {
            setIsLoading(false);
        })
    }

    const getTypesBySector = async (sectorId) => {
        const response = await apiClient.get(`/api/Dictionary/ComplainTypes/${sectorId}`);

        return  response?.data?.map(sector => {
            return {
                value: sector.id,
                text: sector.name
            }
        })
    }

    useEffect(() => {
        fetchSectors();
    }, []);
    
    return {
        sectors,
        isLoading,
        appSectors,
        getTypesBySector
    }
}

export default useSectors;